function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import runLater from "../../../Core/runLater";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import SdmxCatalogGroupTraits from "../../../Traits/TraitsClasses/SdmxCatalogGroupTraits";
import CreateModel from "../../Definition/CreateModel";
import { SdmxServerStratum } from "./SdmxJsonServerStratum";
export default class SdmxCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(SdmxCatalogGroupTraits)))) {
  get type() {
    return SdmxCatalogGroup.type;
  }
  async forceLoadMetadata() {
    if (!this.strata.has(SdmxServerStratum.stratumName)) {
      const stratum = await SdmxServerStratum.load(this);
      runInAction(() => {
        this.strata.set(SdmxServerStratum.stratumName, stratum);
      });
    }
  }
  async forceLoadMembers() {
    const sdmxServerStratum = this.strata.get(SdmxServerStratum.stratumName);
    if (sdmxServerStratum) {
      await runLater(() => sdmxServerStratum.createMembers());
    }
  }
}
_defineProperty(SdmxCatalogGroup, "type", "sdmx-group");